let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eycNO")).then(() => parcelRequire('3qZK6'));